import { createSelector } from 'reselect';
import queryString from 'query-string';

const selectParams = state => queryString.parse(state.router.location.search);

export default createSelector(
  selectParams,
  (params) => params.tab || 'summary'
)